var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#61DAFB"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 20,
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 65,
    r: 20,
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 20,
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 15,
    r: 20,
    fillOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.8c78b730395f99845aa4742314a9f066.svg";
export { ForwardRef as ReactComponent };